module.exports = __webpack_public_path__ + "png/quick-registration-puzzles-bg.png?c237418de4dc91859736543053b1d851";